import { Link } from 'react-router-dom';
import type { Id } from '../../convex/_generated/dataModel';

export function FranchiseLink({
  franchiseId,
  name,
  logoUrl: _logoUrl, // reserved; not rendered in Phase 1
}: {
  franchiseId: Id<'franchises'>;
  name: string;
  logoUrl?: string;
}): JSX.Element {
  return (
    <Link to={`/history/franchises/${franchiseId}`} className="hover:underline">
      {name}
    </Link>
  );
}
